@if (show()) {
<div class="container_spinner">
    <div class="wrapper_spinner">
      <div class="custom-loader">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}